import React from 'react';

export const Isotype = () => (
  <svg
    data-testid="img-logo-v2"
    fill="none"
    height="40"
    viewBox="0 0 40 40"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M38.8031 38.8031H1.19531V1.19531H38.8031V38.8031Z" fill="white" />
    <path d="M40 40V0H0V40H40ZM38.8045 38.8033H1.19667V1.19556H38.8045V38.8033Z" fill="#D71920" />
    <path
      d="M19.9958 18.4078L21.2091 14.4078L22.4402 18.4078H19.9958ZM35.5724 13.3356V10.8245H26.7036V21.4078L22.868 10.8267H19.5513L15.7158 21.4078V15.6989H10.6613V18.09H12.148C12.148 18.4722 11.4046 19.4356 10.1169 19.4356C9.32908 19.4356 7.75467 19.2556 7.75467 16.0278C7.75467 12.8 9.96468 12.83 9.96468 12.83C11.8413 12.83 12.0846 14.2945 12.0846 14.2945H15.4435C14.8691 11.1556 12.2958 10.4056 10.1769 10.3489C8.05798 10.2922 4.42578 11.6045 4.42578 16.0278C4.42578 20.4511 6.90801 22.1234 9.57134 22.1856C12.1447 22.2445 13.2646 20.5711 13.2646 20.5711V22.0656H18.8646L19.3035 20.6311H23.118L23.5558 22.0656H30.2758V18.09H34.4836V15.6989H30.2758V13.3378L35.5724 13.3356Z"
      fill="#D71920"
    />
    <path
      d="M9.39201 29.1774V28.0497H7.03646V27.3241H8.92312V26.1974H7.03646V25.473H9.39201V24.3452H5.45312V29.1774H9.39201Z"
      fill="#D71920"
    />
    <path
      d="M11.5213 24.3452H10.0391V29.1774H11.5557V27.6474V26.6385L13.2191 29.1774H14.7024V24.3452H13.1868V25.8819V26.8897L11.5213 24.3452Z"
      fill="#D71920"
    />
    <path
      d="M19.4947 29.1774V28.0497H17.1391V27.3241H19.0258V26.1974H17.1391V25.473H19.4936V24.3452H15.5547V29.1774H19.4947Z"
      fill="#D71920"
    />
    <path
      d="M21.7262 25.4733H22.464C22.8329 25.4733 23.1017 25.6345 23.1017 25.9767C23.1017 26.3189 22.8395 26.4333 22.3495 26.4333H21.7262V25.4733ZM22.2095 27.4934C22.9473 27.4934 23.0551 27.7011 23.0551 28.3322C23.0437 28.6164 23.0707 28.9008 23.1351 29.1778H24.7384C24.6179 28.8609 24.5613 28.5233 24.5717 28.1845C24.5717 27.2111 24.2628 27.0911 23.7528 26.9033C24.3162 26.7478 24.565 26.2789 24.565 25.7222C24.565 24.7822 24.0339 24.3467 22.4239 24.3467H20.1406V29.1778H21.724V27.4934H22.2095Z"
      fill="#D71920"
    />
    <path
      d="M29.9257 26.519H27.7591V27.5668H28.4569C28.3758 27.9001 27.9669 28.1224 27.6446 28.1224C26.8458 28.1224 26.6313 27.4979 26.6313 26.8135C26.6313 25.9612 26.9269 25.3979 27.5502 25.3979C27.7357 25.3876 27.919 25.4432 28.0675 25.5548C28.2161 25.6664 28.3206 25.8269 28.3624 26.0079H29.8657C29.6713 24.8201 28.738 24.2168 27.5769 24.2168C26.0135 24.2168 25.0469 25.2768 25.0469 26.8201C25.0469 28.5046 26.1579 29.3035 27.3891 29.3035C28.1479 29.3035 28.5835 29.0212 28.8458 28.7123V29.189H29.9257V26.5224V26.519Z"
      fill="#D71920"
    />
    <path
      d="M33.1908 27.4185L34.9886 24.3452H33.2308L32.3986 25.983L31.5664 24.3452H29.8086L31.6064 27.4185V29.1774H33.1908V27.4185Z"
      fill="#D71920"
    />
  </svg>
);
